import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Div, Headline, Gutter, Flex, Button, Title } from '@gaiads/telia-react-component-library';
import { Card, GenericTable } from '@cdaas/reusable-components-daas';

import { showGrowlNotification } from '../../../../store/actions';
import { User } from '../../../../types';
import { IMPORT_USERS_FLOW_CONSTANTS } from '../../../../utils/constants';
import { getCardProps, getRowConfig, groupUsersByGroup } from '../utils';

type SummaryProps = {
  usersToImport: User[];
};

const getUsersByGroup = (users: User[]) => {
  const userWithoutGroup: User[] = [];
  const usersWithGroup = groupUsersByGroup(users, userWithoutGroup);
  for (const group of usersWithGroup) {
    group.users = group.users.slice().sort((a, b) => {
      if (!a.error && !!b.error) {
        return 1;
      } else if (!!a.error && !b.error) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  return usersWithGroup;
};

const Summary: FunctionComponent<SummaryProps> = ({ usersToImport }) => {
  const { t } = useTranslation('editOrganization');
  const history = useHistory();
  const grouppedUsers = getUsersByGroup(usersToImport);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showGrowlNotification(t('usersAdmin.importUsers.usersSaved.usersSavedSuccessfully'), 'success'));
  }, [dispatch, t]);

  return (
    <Div>
      <Headline size="md">{t('usersAdmin.importUsers.usersSaved.title')}</Headline>
      <Gutter size={'layout-7'} />
      <Title size="sm">{t('usersAdmin.importUsers.usersSaved.savedAndInvitationSent')}</Title>
      <Gutter size={'layout-7'} />
      {grouppedUsers.map(group => {
        return (
          <Card {...getCardProps(group, t)} key={group.userGroup}>
            <GenericTable
              loading="none"
              inputData={group.users}
              noDataText={t('usersAdmin.importUsers.reviewAndSave.noUsersText')}
              rowConfigs={getRowConfig()}
              isGenericTableInsideCard={true}
            />
          </Card>
        );
      })}
      <Flex>
        <Button onClick={() => history.push('/users')} variant={'primary'}>
          {t('usersAdmin.importUsers.usersSaved.goToUsersPageButton')}
        </Button>
        <Gutter size={'sm'} />
        <Button onClick={() => history.push(`${IMPORT_USERS_FLOW_CONSTANTS.uploadTemplate}`)} variant={'secondary'}>
          {t('usersAdmin.importUsers.usersSaved.importMoreUsersButton')}
        </Button>
      </Flex>
    </Div>
  );
};

export default Summary;
